'use strict';
import { render } from 'react-dom';
import Survey from './../components/Survey/Survey';

function run(containerId) {
	const container = document.getElementById(containerId);

	if (container) {
		render(<Survey />, container);
	}
}

export { run };
